import { MapFilterRequiredData } from "../../../model/map-filter-required-data";
import { MapContext } from "../map.component";
import { LocationForMap, ThingForMap } from "../map.service";

export interface MapFilter {
    setContext(context: MapContext): void;
    getConfig(): any;
    computeRank(elements: ThingForMap[] | LocationForMap[], data: any): void;
    updateMarker(element: ThingForMap | LocationForMap, marker: any): void;
    getRankDescriptors(elements: ThingForMap[] | LocationForMap[]): any[];
    getRequiredData(): MapFilterRequiredData;
    onInit?(): Promise<any>;
}

export const MARKER_SVG = `<svg width="26" height="40" viewBox="0 0 26 40" xmlns="http://www.w3.org/2000/svg">
<path d="M1 13C1.00036 19.9142 8.08249 32.7303 11.3652 38.2994C12.1115 39.5656 13.8885 39.5656 14.6348 38.2994C17.9175 32.7303 24.9995 19.9142 24.9996 13C24.9996 6.37258 19.6274 1 13 1C6.37258 1 0.999654 6.37258 1 13Z" />
</svg>`;